var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cs-1 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cs-1, .cs-2 {\r\n        stroke: #000;\r\n      }\r\n\r\n      .cs-1, .cs-2, .cs-3 {\r\n        fill: none;\r\n      }\r\n\r\n      .cs-2 {\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cs-2",
    cx: 24.23,
    cy: 23.7,
    rx: 12.94,
    ry: 16.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cs-2",
    d: "m9.67,18.67c1.03-7.67,6.09-13.67,14.56-13.67s13.53,6,14.56,13.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cs-1",
    d: "m9.36,29.84c.62,6.77,3.54,12.06,10.11,13.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cs-2",
    d: "m11.29,23.7c0-1.75.14-3.44.43-5.03h-4.2c-1.03,0-1.87.84-1.87,1.87v7.43c0,1.03.84,1.87,1.87,1.87h4.38c-.42-1.9-.61-3.97-.61-6.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cs-2",
    d: "m37.17,23.7c0-1.75-.14-3.44-.43-5.03h4.2c1.03,0,1.87.84,1.87,1.87v7.43c0,1.03-.84,1.87-1.87,1.87h-4.38c.42-1.9.61-3.97.61-6.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cs-2",
    x: 19.41,
    y: 41.48,
    width: 5.25,
    height: 3.52,
    rx: 1.14,
    ry: 1.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cs-2",
    d: "m25.26,31.19c-.57.33-1.49.33-2.05,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cs-2",
    d: "m27.13,35.53c-1.6,1.53-4.2,1.53-5.8,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cs-2",
    d: "m11.45,20.64s10.76-2.83,14.56-6.74c0,0,.17,3.4-1.08,4.37,0,0,3.23-.74,4.65-2.66,0,0,.91,2.18-.17,3.2,0,0,3.36.53,6.61-2.95"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cs-3",
    width: 50,
    height: 50
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCs);
export default __webpack_public_path__ + "static/media/icon-cs.d5919cd5d41db28e922f12900699465e.svg";
export { ForwardRef as ReactComponent };